/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable @getify/proper-ternary/nested */
import { Divider, Drawer, Tab, Tabs } from '@material-ui/core';
import styled from 'styled-components/macro';
import styledMixins from 'app/styles/styledMixins';
import React, { useEffect, useState, useRef } from 'react';
import styledFuncs from 'app/styles/styledFuncs';
import Button from 'app/shared/components/button/Button';
import { MaterialUiPickersDate } from '@material-ui/pickers/typings/date';
import { KeyboardDatePicker } from '@material-ui/pickers';
import ProductPictureOrDefault from 'app/shared/components/app-image/ProductPictureOrDefault';
import { productImg } from 'app/core/api/product-assignment/api-product-assignment.types';
import {
  ChatEventType,
  EventEntity,
  QuotePayment,
  QuoteSummeryUpdate,
  RepairCase,
} from 'app/core/api/repairer/api-repairer.types';
import Body from 'app/shared/components/typography/body/Body';
import { DefectTypesMap } from 'app/consumer-app/views/report-fault/report-fault-utils';
import {
  useEffectOnChanges,
  useUrlParams,
  useWatchAsRef,
} from 'app/tools/hooks/misc-hooks';
import {
  useCreateRepairEvent,
  useQuotePayment,
  useQuoteSummery,
  useUpdateQuoteSummery,
} from 'app/core/api/repairer/api-repairer';
import { useSetPageTitle } from 'app/shared/context-hooks/use-titlebar.hook';
import { useShowInfo } from 'app/shared/context-hooks/use-show-info.hook';
import { makeStyles } from '@material-ui/core/styles';
import { appEnv } from 'app/core/environment';
import QuoteAddress from './quote-address';
import QuotePaymentDetails from './quote-payment-details';
import QuoteDetails from './quote-details';
// import QuoteDetails from './quote-details';

const QuoteTabs = styled(Tabs)`
  ${styledMixins.softShadow}
`;
const DetailsTitle = styled(Body)`
  font-weight: 500;
  font-size: 15px;
  color: #31ad31;
  + * {
    margin: ${styledFuncs.pad(0.5)} ${styledFuncs.pad(1.5)} 0;
  }
`;
// const TaskDetailContainer = styled.div`
//   display: flex;
//   margin: ${styledFuncs.pad(2)};
//   text-align: center;
// `;
const imgHeight = 100;

const ProductPicture = styled(ProductPictureOrDefault)`
  width: ${imgHeight}px;
  padding: 0;
`;

const TabPanel: React.FC<{ index: number; activeTab: number }> = ({
  children,
  index,
  activeTab,
}) => (
  <div
    role="tabpanel"
    id={`wrapped-tabpanel-${index}`}
    aria-labelledby={`wrapped-tab-${index}`}
    css={`
      flex: 1 1 100%;
      display: ${activeTab === index ? 'flex' : 'none'};
    `}
  >
    {activeTab === index && children}
  </div>
);

const useStyles = makeStyles({
  drawerPaper: {
    maxHeight: 518,
  },
});

type Props = {
  quoteEventEntity?: EventEntity | undefined;
  isQuoteDrawerOpen: boolean;
  SetIsQuoteDrawerOpen: (isVisible: boolean) => unknown;
  setIsQuoteDetailOpen: (isVisible: boolean) => unknown;
  repairCase: RepairCase | undefined;
  SetIsShowTracking: (isVisible: boolean) => unknown;
  isLastMessage: string | undefined;
};
export default function QuoteDrawer({
  quoteEventEntity,
  isQuoteDrawerOpen,
  SetIsQuoteDrawerOpen,
  setIsQuoteDetailOpen,
  repairCase,
  SetIsShowTracking,
  isLastMessage,
}: Props): JSX.Element {
  const { id } = useUrlParams(['id']);
  const {
    resource: quoteSummery,
    loading,
    loadingMissing,
    request,
  } = useQuoteSummery(id);
  const { request$: updateQuoteSummery$ } = useUpdateQuoteSummery();
  const {
    request$: updateQuotePayment$,
    sending: updateQuotePayment,
    error: apiError,
  } = useQuotePayment();
  const loadingRef = useWatchAsRef(loading);

  const titleMsg = loadingMissing ? 'Loading...' : `Task Info`;
  useEffect(() => {
    if (!loadingRef.current) request();
  }, [loadingRef, request]);
  useEffectOnChanges(() => {
    if (isQuoteDrawerOpen) request();
  }, [isQuoteDrawerOpen, request]);
  useSetPageTitle(titleMsg);
  const [isShowPaymentOption, setIsShowPaymentOption] =
    useState<boolean>(false);
  const [activeTab, setActiveTab] = useState(1);
  const [isQuoteAccepted, setIsQupteAccepted] = useState(false);
  const onTabChange = (val: unknown) => {
    setActiveTab(val as number);
  };
  const issueType =
    DefectTypesMap.get(repairCase?.productDefectDetails?.title) ||
    repairCase?.productDefectDetails?.title;

  const ButtonContainer = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-between;
    margin: 0 auto;
  `;
  const ButtonSelector = styled(Button)`
    background: #ffffff;
    box-shadow: 0px 3px 10px rgba(0, 0, 0, 0.161);
    border-radius: 10px;
    height: 46px;
    color: #31ad31;
    margin: ${styledFuncs.pad(0.5)};
    :hover {
      color: white;
    }
  `;
  const [selectedDate, setSelectedDate] = useState<string>();
  const [deliveryLocation, setDeliveryLocation] = useState<number>();
  const [paymentMethodId, setPaymentMethodId] = useState<string>();
  const [type, setType] = useState<string>();
  const [acceptReject, setAcceptReject] = useState<boolean>();
  const { request$: createRepairEvent$ } = useCreateRepairEvent();

  const { showSnack } = useShowInfo();

  const onChange = (
    date: MaterialUiPickersDate,
    value?: string | null | undefined
  ) => {
    setSelectedDate(`${value ?? ' 00:00'}`);
  };
  const createOrder = () => {
    const amount = quoteSummery?.diagnosisQuote
      ? quoteSummery.diagnosisQuote
          .map(item => item.quotationAmount.amount)
          .reduce((prev, curr) => prev + curr, 0)
      : 0;

    const amount1 = quoteSummery?.repairQuote
      ? quoteSummery?.repairQuote
          .map(item => item.quotationAmount.amount)
          .reduce((prev, curr) => prev + curr, 0)
      : 0;
    const summery: QuoteSummeryUpdate = {
      id: repairCase?.id ?? 0,
      deliveryLocation: deliveryLocation ?? 0,
      pickUpDate: `${selectedDate ?? ''} 10:00`,
      dropOffDate: `${selectedDate ?? ''} 10:00`,
    };
    updateQuoteSummery$(summery).subscribe(() => {
      const payment: QuotePayment = {
        repairCaseId: repairCase?.id ?? 0,
        amount: (amount + amount1)?.toString() ?? '',
        currency: 'GBP',
        paymentMethodId: paymentMethodId ?? '',
      };
      // eslint-disable-next-line rxjs/no-nested-subscribe
      updateQuotePayment$(payment).subscribe(() => {
        SetIsQuoteDrawerOpen(false);
        setIsQuoteDetailOpen(true);
        SetIsShowTracking(true);
      });
    });
  };

  const classes = useStyles();
  useEffectOnChanges(() => {
    if (apiError && apiError.errorMessage) {
      showSnack({ message: apiError.errorMessage ?? '' });
    }
  }, [apiError, showSnack]);
  const date = useRef<null | HTMLDivElement>(null);
  const payment = useRef<null | HTMLDivElement>(null);

  useEffectOnChanges(() => {
    if (isQuoteAccepted && type) {
      date.current?.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
        inline: 'start',
      });
    }
  });
  useEffect(() => {
    // (repairCase?.caseStatus === 'diagnosis_quote_issued' ||
    //     repairCase?.caseStatus === 'repair_quote_issued') &&
    //  ;
    if (
      isLastMessage === 'diagnosis_quote_issued' &&
      appEnv.APP_VARIANT === 'consumer' &&
      quoteEventEntity?.eventType === ChatEventType.DIAGNOSIS_QUOTE
    ) {
      setAcceptReject(true);
    } else if (
      isLastMessage === 'repair_quote_issued' &&
      appEnv.APP_VARIANT === 'consumer' &&
      quoteEventEntity?.eventType === ChatEventType.REPAIR_QUOTE
    ) {
      setAcceptReject(true);
    } else {
      setAcceptReject(false);
    }
    // if (
    //   quoteEventEntity?.eventType ===
    //     ChatEventType.DIAGNOSIS_QUOTE_DECLINE ||
    //   quoteEventEntity?.eventType ===
    //     ChatEventType.REPAIR_QUOTE_DECLINE
    // ) {
    //   setAcceptReject(false);
    // }
  }, [isLastMessage, quoteEventEntity?.eventType]);
  const handleClick = () => {
    payment.current?.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
      inline: 'start',
    });
  };
  const declineQuote = () => {
    // const sendChatData = {
    //   displayText: '',
    //   eventType: repairCase?.isDiagnosisPaymentDone
    //     ? ChatEventType.REPAIR_QUOTE_DECLINE
    //     : repairCase?.isDiagnosisPaymentDone &&
    //       repairCase?.paymentStatus === 'None'
    //     ? ChatEventType.REPAIR_QUOTE_DECLINE
    //     : ChatEventType.DIAGNOSIS_QUOTE_DECLINE,
    // };
    const sendChatData = {
      displayText: '',
      eventType:
        quoteEventEntity?.eventType === ChatEventType.DIAGNOSIS_QUOTE
          ? ChatEventType.DIAGNOSIS_QUOTE_DECLINE
          : ChatEventType.REPAIR_QUOTE_DECLINE,
    };
    const messageSentObserver = {
      next: () => SetIsQuoteDrawerOpen(false),
      error: () =>
        showSnack({
          message: 'Something went wrong! Please try again.',
        }),
    };
    const caseIdObj = { repairCase: +id };
    createRepairEvent$({ ...caseIdObj, ...sendChatData }).subscribe(
      messageSentObserver
    );
    SetIsQuoteDrawerOpen(false);
  };
  const acceptQuote = () => {
    if (repairCase?.isDiagnosisPaymentDone) {
      const messageSentObserver = {
        next: () => SetIsQuoteDrawerOpen(false),
        error: () =>
          showSnack({
            message: 'Something went wrong! Please try again.',
          }),
      };
      const caseIdObj = { repairCase: +id };
      const sendChatData = {
        displayText: '',
        eventType: ChatEventType.REPAIR_QUOTE_ACCEPT,
      };
      createRepairEvent$({ ...caseIdObj, ...sendChatData }).subscribe(
        messageSentObserver
      );
      SetIsQuoteDrawerOpen(false);
    } else {
      setIsQupteAccepted(true);
    }
  };
  const resetAll = () => {
    setIsQupteAccepted(false);
    setType('');
    setIsShowPaymentOption(false);
    SetIsQuoteDrawerOpen(false);
  };
  return (
    <>
      <Drawer
        anchor="bottom"
        open={isQuoteDrawerOpen}
        onClose={() => resetAll()}
        classes={{
          paper: classes.drawerPaper,
        }}
      >
        <div
          style={{
            position: 'fixed',
            width: '100%',
            backgroundColor: '#fff',
            zIndex: 1,
          }}
        >
          <QuoteTabs
            value={activeTab}
            onChange={(e, val) => onTabChange(val)}
            variant="fullWidth"
            textColor="primary"
            indicatorColor="primary"
            style={{ zIndex: 999 }}
          >
            <Tab value={0} label="Details" />
            <Tab value={1} label="Quotation" />
          </QuoteTabs>
        </div>
        <div style={{ position: 'relative', marginTop: '30px' }}>
          <TabPanel index={0} {...{ activeTab }}>
            <div
              style={{
                display: 'block',
                margin: '30px auto',
                overflowY: 'scroll',
              }}
            >
              <ProductPicture
                pendingSrc={loadingMissing}
                productId={
                  repairCase?.productDefectDetails
                    .assignedProductDetails.productDetails?.id
                }
                src={productImg(
                  repairCase?.productDefectDetails
                    .assignedProductDetails
                )}
                height={`${imgHeight}px`}
                css={{ margin: '0 auto' }}
              />
              <div
                style={{
                  display: 'flex',
                  alignItems: 'stretch',
                }}
              >
                <div style={{ width: '48.5%', textAlign: 'center' }}>
                  <DetailsTitle>Product Name</DetailsTitle>
                  <Body small>
                    {
                      repairCase?.productDefectDetails
                        .assignedProductDetails.productDetails?.name
                    }
                  </Body>
                </div>
                <div style={{ width: '1%' }}>
                  <Divider
                    orientation="vertical"
                    flexItem
                    style={{
                      height: '100%',
                      width: '1px',
                      backgroundColor: '#000000',
                    }}
                  />
                </div>
                <div style={{ width: '48.5%', textAlign: 'center' }}>
                  <DetailsTitle>Issue Type</DetailsTitle>
                  <Body small>{issueType}</Body>
                </div>
              </div>
              <div style={{ paddingTop: '20px' }}>
                <DetailsTitle color="primary">
                  User Description
                </DetailsTitle>
                <Body small>
                  {repairCase?.productDefectDetails?.description}
                </Body>
              </div>
              {/*   <Button css={{ margin: '0 auto', display: 'flex' }}>
                View my product
              </Button> */}
            </div>
          </TabPanel>
          <TabPanel index={1} {...{ activeTab }}>
            {quoteSummery ? (
              <div
                style={{
                  display: 'block',
                  margin: '30px 20px 20px 20px',
                }}
              >
                <div>
                  {isQuoteAccepted && isLastMessage && (
                    <Button
                      style={{
                        width: '100%',
                        marginBottom: '20px',
                        backgroundColor: '#F6645B',
                      }}
                      fullWidth
                      onClick={() => {
                        setIsQupteAccepted(false);
                        SetIsQuoteDrawerOpen(false);
                      }}
                    >
                      Cancel
                    </Button>
                  )}
                  <QuoteDetails
                    quoteSummery={quoteSummery}
                    quoteEventEntity={quoteEventEntity}
                  />
                </div>
                {!isQuoteAccepted && acceptReject && (
                  <div>
                    <Button
                      style={{
                        width: '49%',
                        height: '46px',
                        marginRight: '1%',
                        marginBottom: '20px',
                        backgroundColor: '#31AD31',
                      }}
                      fullWidth
                      onClick={() => acceptQuote()}
                    >
                      Accept
                    </Button>
                    <Button
                      style={{
                        width: '49%',
                        height: '46px',
                        marginLeft: '1%',
                        marginBottom: '20px',
                        backgroundColor: '#F6645B',
                      }}
                      fullWidth
                      onClick={() => declineQuote()}
                    >
                      Decline
                    </Button>
                  </div>
                )}
                {isQuoteAccepted && (
                  <div>
                    <p style={{ marginBottom: '10px' }}>
                      Please select one of following*
                    </p>
                    <ButtonContainer>
                      <ButtonSelector
                        onClick={() => {
                          setType(
                            type === 'drop_off' ? '' : 'drop_off'
                          );
                        }}
                        style={
                          type === 'drop_off'
                            ? {
                                backgroundColor: '#31AD31',
                                color: 'white',
                                width: '46%',
                              }
                            : { width: '46%' }
                        }
                      >
                        Drop Off
                      </ButtonSelector>
                      <ButtonSelector
                        onClick={() => {
                          setType('home_visit');
                        }}
                        style={
                          type === 'home_visit'
                            ? {
                                backgroundColor: '#31AD31',
                                color: 'white',
                                width: '46%',
                                fontSize: '13px',
                              }
                            : {
                                width: '46%',
                                fontSize: '11px',
                              }
                        }
                        disabled
                      >
                        Home Visit
                        <br />
                        (coming soon)
                        {/* < style={{ fontSize: '10px' }}>
                          (coming soon)
                        </> */}
                      </ButtonSelector>
                      <ButtonSelector
                        onClick={() => {
                          setType('home_visit');
                        }}
                        style={
                          type === 'home_visit'
                            ? {
                                backgroundColor: '#31AD31',
                                color: 'white',
                                width: '46%',
                              }
                            : {
                                width: '46%',
                                fontSize: '11px',
                              }
                        }
                        disabled
                      >
                        Courier Pick-up
                        <br />
                        (coming soon)
                      </ButtonSelector>
                    </ButtonContainer>
                    {/* <ButtonSelector onClick={() => {}}>
                    We Collect
                  </ButtonSelector> */}
                    {type && (
                      <div ref={date}>
                        <p style={{ margin: '20px 10px 0 0' }}>
                          Please select a date{' '}
                        </p>
                        <KeyboardDatePicker
                          variant="static"
                          format="yyyy-MM-dd"
                          KeyboardButtonProps={{
                            'aria-label': 'change date',
                          }}
                          name="startDate"
                          value={selectedDate}
                          onChange={onChange}
                          onClick={handleClick}
                          disablePast
                          disableToolbar
                          rightArrowButtonProps={{
                            style: { zIndex: 0 },
                          }}
                          leftArrowButtonProps={{
                            style: { zIndex: 0 },
                          }}
                        />
                      </div>
                    )}
                  </div>
                )}
                <div ref={payment}>
                  {selectedDate &&
                    type === 'home_visit' &&
                    !isShowPaymentOption && (
                      <QuoteAddress
                        setIsShowPaymentOption={
                          setIsShowPaymentOption
                        }
                        setDeliveryLocation={setDeliveryLocation}
                        deliveryLocation={deliveryLocation ?? 0}
                      />
                    )}
                  {(isShowPaymentOption ||
                    (selectedDate && type === 'drop_off')) && (
                    <QuotePaymentDetails
                      setPaymentMethodId={setPaymentMethodId}
                      createOrder={createOrder}
                      paymentMethodId={paymentMethodId ?? ''}
                      quoteSummery={quoteSummery}
                      sending={updateQuotePayment}
                    />
                  )}
                </div>
              </div>
            ) : (
              <></>
            )}
          </TabPanel>
        </div>
      </Drawer>
    </>
  );
}
